'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createRestClient = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var baseErrorType = 'https://www.wixrestaurants.com/errors/';

var parseSuccess = function parseSuccess(response) {
    // some requests return empty response
    return _q2.default.resolve(response.data);
};

var parseError = function parseError(error) {
    if (error.response && error.response.data) {
        return _q2.default.reject(error.response.data);
    } else {
        switch (error.code) {
            case 'ECONNABORTED':
                return _q2.default.reject({
                    type: baseErrorType + 'timeout',
                    title: 'Timeout',
                    detail: 'request timed out'
                });
            case 'ENOTFOUND': // fall through
            default:
                return _q2.default.reject({
                    type: baseErrorType + 'network',
                    title: 'Network Down',
                    detail: 'network is down'
                });
        }
    }
};

var normalizeQueryParamValue = function normalizeQueryParamValue(value) {
    return Array.isArray(value) ? value.join(',') : value;
};

var normalizeQueryParams = function normalizeQueryParams(params) {
    return Object.entries(params).reduce(function (obj, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];

        return Object.assign(obj, _defineProperty({}, name, normalizeQueryParamValue(value)));
    }, {});
};

var createRestClient = exports.createRestClient = function createRestClient() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$baseUrl = _ref3.baseUrl,
        baseUrl = _ref3$baseUrl === undefined ? 'https://api.wixrestaurants.com/v2' : _ref3$baseUrl,
        _ref3$timeout = _ref3.timeout,
        timeout = _ref3$timeout === undefined ? 0 : _ref3$timeout;

    return function (path) {
        var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
        var params = arguments[2];
        var auth = arguments[3];

        var headers = {
            Accept: 'application/json'
        };
        if (auth) {
            if (typeof auth === 'string') {
                headers.Authorization = 'Bearer ' + auth;
            } else {
                headers.Authorization = auth.type + ' ' + auth.credentials;
            }
        }

        var query = method === 'get' && params ? _qs2.default.stringify(normalizeQueryParams(params), { addQueryPrefix: true }) : '';
        var url = '' + baseUrl + path + query;

        var request = {
            method: method,
            url: url,
            headers: headers,
            timeout: timeout
        };
        if (method !== 'get' && params) {
            request.data = params;
        }

        return (0, _axios2.default)(request).then(parseSuccess, parseError);
    };
};